import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ThinAddIcon, ThinTrashIcon, TomansIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {RemoveModal} from "../../../components/template/remove-modal";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {AdminsAddExtraPaymentModal} from "./add-extra";
import {Link, useNavigate} from "react-router-dom";

interface paymentInterface {
    id: number,
    title: string,
    isAvailableForAll: 0 | 1,
    class: string,
    price: number,
    expiresAt: string,
    createdAt: string,
    totalPaid: number,
    countPaid: number,
    optional:0|1,
}

export const AdminsExtraPaymentsListScreen = () => {
    const [list, setList] = useState<paymentInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [canAdd,setCanAdd] = useState(false);
    const navigate = useNavigate();
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/extra/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: paymentInterface[] | null,
                canAdd:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
                setCanAdd(d.canAdd);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "پرداخت متفرقه | اتوماسیون شهاب";
        fetchList();
    }, []);
    const [newModal, setNewModal] = useState(false);
    const [removeModal, setRemoveModal] = useState({
        show: false,
        id: 0,
        title: '',
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'پرداخت‌های متفرقه', url: '/admins/extra'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>پرداخت‌های متفرقه</b>
                                {
                                    canAdd ?
                                        <button onClick={() => setNewModal(true)}>
                                            <ThinAddIcon/>
                                            <span>پرداخت جدید</span>
                                        </button> : null
                                }
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>عنوان</th>
                                    <th>نوع</th>
                                    <th>قیمت</th>
                                    <th>انقضا</th>
                                    <th>کل دریافتی</th>
                                    <th>تعداد پرداخت</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"QQs39ruWsj39" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>
                                                <Link to={`/admins/extra/view/${s.id}`}>
                                                    {s.title}
                                                </Link>
                                            </td>
                                            <td>{s.isAvailableForAll ? 'همگانی' : (s.class !== '' ? ("مخصوص " + s.class) : 'افراد خاص')}</td>
                                            <td>
                                                {
                                                    s.optional === 1 ? 'انتخابی' :
                                                        <span>{CurrencyFormat(s.price)}<TomansIcon/></span>
                                                }
                                            </td>
                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(s.expiresAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                            <td>
                                                <span>{CurrencyFormat(s.totalPaid)}<TomansIcon/></span>
                                            </td>
                                            <td>{CurrencyFormat(s.countPaid)}</td>
                                            <td>
                                                {
                                                    canAdd ?
                                                        <button className="open-tooltip" onClick={() => setRemoveModal({
                                                            title: s.title,
                                                            show: true,
                                                            id: s.id,
                                                        })}>
                                                            <i>حذف</i>
                                                            <ThinTrashIcon/>
                                                        </button> : null
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف پرداخت"}
                desc={"آیا مطمئن هستید که می‌خواهید " + removeModal.title + " را حذف کنید؟"}
                onRemove={() => {
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/extra/remove',
                        {
                            id: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'پرداخت حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
            <AdminsAddExtraPaymentModal
                active={newModal}
                closeHandler={() => setNewModal(false)}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
            />
        </>
    );
};